import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import DriveItemList from '../../components/DriveItemList';
import DriveItemUtils from '../../utils/driveItem';
import Utils from '../../utils';
import RoutesUtils from '../../utils/routes';
import { RoutePath } from '../../routes/constants';

interface DriveItemListOwnProps {
	navigationItems: JSX.Element[];
	folderId?: number;
}

const mapStateToProps = (state: StoreState, ownProps: DriveItemListOwnProps) => {
	const { driveList, routerParamsHistory, galleryInfos, galleryInfos: { template: { search: searchConfig } }, appInfos, profile } = state;
	const isMultiApp = Utils.isMultiApp(appInfos);
	const { driveItems, isEditMode, isLoading } = driveList;
	const { folderId } = ownProps;
	const privateDirId = Utils.getPrivateDirId(driveList, galleryInfos.config);
	const currentFolderId = Utils.getCurrentFolderId(galleryInfos.config.applicationGallery, routerParamsHistory);
	const isPrivateDir = privateDirId === currentFolderId;
	const isReadOnlyApp = Utils.isReadOnlyApp(profile.role);
	const currentRoute = routerParamsHistory[routerParamsHistory.length - 1];
	const { routes } = currentRoute;
	const isEditButtonDisplayed = DriveItemUtils.isFolderEditableForCurrentUser(folderId, state) && !isReadOnlyApp;

	return {
		displayType: DriveItemUtils.getDisplayType(driveList, routerParamsHistory, folderId),
		storeDriveItems: driveItems,
		isPrivateDir,
		sharedDirId: Utils.getSharedDirId(driveList, galleryInfos.config),
		sourcesDirId: Utils.getSourcesDirId(driveList, galleryInfos.config),
		searchConfig,
		isEditMode,
		isEditButtonDisplayed,
		isLoading,
		shouldGetCustomTemplates: isMultiApp && !isReadOnlyApp,
		isTheaterOpened: RoutesUtils.doesRoutesContainsPath(RoutePath.TheaterList, routes),
	};
};

export default connect(mapStateToProps)(DriveItemList);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/index.tsx